// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"2082c6fb","453":"1b1b31ed"}[chunkId] + ".chunk.js";
};